/***
 *
 *   UBO REPORT PDF ERROR HELPERS
 *   Pure logic for turning a failed PDF request into a message worth showing.
 *   Kept separate from the view so it can be unit tested without rendering the
 *   whole EntityOnboardingReportView.
 *
 **********/

/**
 * Pull the API's error message out of a failed PDF request.
 *
 * The PDF request sets `responseType: "blob"`, so Axios hands back a Blob for
 * error responses too — `err.response.data.message` is `undefined` and the JSON
 * body has to be read out of the Blob explicitly. Anything unparseable (an
 * HTML gateway error page, an empty body, a network failure with no response)
 * falls back rather than surfacing a parser error to the user.
 *
 * @param {object} err - the rejected Axios error
 * @param {string} fallback - message to show when nothing better is available
 * @returns {Promise<string>}
 */
export async function readBlobErrorMessage(err, fallback) {
  const body = err?.response?.data;

  try {
    if (typeof Blob !== "undefined" && body instanceof Blob) {
      const text = await body.text();
      return JSON.parse(text)?.message || fallback;
    }

    return body?.message || fallback;
  } catch (e) {
    return fallback;
  }
}
